import styled from 'styled-components';
import {primary, neutral, success} from '../../style/colors';

export const Button = styled.button`
  background: transparent;
  border: 1px solid ${neutral[200]};
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${neutral[500]};
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    background: ${neutral[100]};
    border-color: ${primary[500]};
    color: ${primary[500]};
  }

  &:active {
    transform: scale(0.95);
  }

  i {
    font-size: 16px;
  }

  ${(props) =>
    props.copied &&
    `
    background: ${success.base};
    border-color: ${success.base};
    color: white;
    
    &:hover {
      background: ${success.dark};
      border-color: ${success.dark};
      color: white;
    }
  `}

  ${(props) =>
    props.compact &&
    `
    padding: 4px 8px;
    font-size: 12px;
    
    i {
      font-size: 14px;
    }
  `}
`;
